import { AppConfig } from './AppConfig';

const baseUrl = 'http://localhost:5001';
const basePlannerUrl = 'http://localhost:8080';

const config: AppConfig = {
  configName: 'LOCAL_DEV',
  applicationTitle: 'WebGardes',
  hubUrl: `${baseUrl}/pharmagardeHub`,
  apiUrl: `${baseUrl}/api/`,
  plannerApiUrl: `${basePlannerUrl}/planner/`,
  dateFormat: 'DD/MM/YYYY',
  dateFormatWithDay: 'ddd DD/MM/YYYY',
  dateTimeFormat: 'DD/MM/YYYY HH:mm',
  dateTimeFormatWithDetails: 'DD/MM/YYYY HH:mm:ss.ss',
  googleMapApiKey: 'AIzaSyAHKfZ1yH7pudlmQ4441Plv9Aiic1tunQc', // 'AIzaSyDmGkzn-SGGe3cnwIAopogWMYvT7_cJNV8'
};

export default config;
